import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import Loading from './Loading';

export default compose(withRouter)(Loading);
